import { render } from "./FactorReport.vue?vue&type=template&id=62a61751&scoped=true"
import script from "./FactorReport.vue?vue&type=script&lang=js"
export * from "./FactorReport.vue?vue&type=script&lang=js"

import "./FactorReport.vue?vue&type=style&index=0&id=62a61751&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a61751"]])

export default __exports__